import React from "react";
import { useTranslation } from "react-i18next";
import { Formik, Form, Field } from "formik";
import Icon from "../../Icon";
import styles from "./CardSelection.module.scss";
import { ICardSelectionProps } from "types/cardSelection.type";

const CardSelection: React.FC<ICardSelectionProps> = ({ cards, price, onSubmit, onBack, disabled = false }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.containerWrapper}>
            <div className={styles.container}>
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        onBack();
                    }}
                    className={styles.back}
                >
                    <Icon.CaretLeft size={12} color={"#C32B3E"} />
                    &nbsp; {t("buy.backToBuy")}
                </a>

                <h1 className={styles.header}>{t("buy.cardPayment")}</h1>

                <Formik
                    initialValues={{ cardToken: "" }}
                    onSubmit={(data) => {
                        const paymentMethod = data.cardToken === "new" ? "Card" : "CardToken";
                        onSubmit(paymentMethod, data.cardToken);
                    }}
                >
                    {() => (
                        <Form>
                            <div className={styles.radioGroup}>
                                {cards.map((card) => (
                                    <label className={styles.radioOption} key={card.token}>
                                        <Field type="radio" name="cardToken" value={card.token} required />
                                        <div className={styles.radioLabel}>
                                            <span>{card.name}</span>
                                            <span>•••• {card.cardMaskedCLN.slice(-4)}</span>
                                        </div>
                                    </label>
                                ))}
                                <label className={styles.radioOption}>
                                    <Field type="radio" name="cardToken" value="new" required />
                                    <div className={styles.radioLabel}>
                                        <span>{t("buy.newCard")}</span>
                                    </div>
                                </label>
                            </div>

                            <div className={styles.buyTicket}>
                                <button disabled={disabled} type="submit" className={`${styles.buyButton} ${styles.buttonFull}`}>
                                    <Icon.PaymentCard className={styles.actionIcon} size={16} />
                                    &nbsp;&nbsp;{t("buy.payByCard")}
                                    &nbsp;-&nbsp;
                                    {price} {t("global.currency.czk")}
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default CardSelection;
